import React from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core'
import { Thermometer } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { SystemContainerList } from '../system-container/SystemContainerList'
import { EnergyBusFragment } from '../../generated/graphql'
import { activeVersionVar } from '../../apollo/reactive-vars'
import { isConnectedToEnergyBus } from '../../building/building-util'

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 50,
    height: 50,
    borderRadius: 25,
    background: theme.palette.common.white,
  },
  buildingCount: {
    color: theme.palette.grey[500],
  },
}))

type Props = {
  energyBuses: EnergyBusFragment[]
  onEnergyBusClick: (energyBus: EnergyBusFragment) => void
}

export function EnergyBusList({
  energyBuses,
  onEnergyBusClick,
}: Props): React.ReactElement {
  const classes = useStyles()
  const { t } = useTranslation()
  const activeVersion = useReactiveVar(activeVersionVar)

  const connectedBuildingCount =
    activeVersion?.buildings.filter(isConnectedToEnergyBus).length ?? 0

  return (
    <SystemContainerList
      items={energyBuses}
      idGetter={(energyBus) => energyBus.id}
      renderItem={() => (
        <Box className={classes.item}>
          <Box className={classes.iconContainer}>
            <Thermometer />
          </Box>
          <Box mt={3}>
            <Typography variant="h6">{t('energyBus.name')}</Typography>
            <Typography className={classes.buildingCount}>
              {t('project.buildingsConnected', {
                count: connectedBuildingCount,
              })}
            </Typography>
          </Box>
        </Box>
      )}
      onItemClick={onEnergyBusClick}
    />
  )
}
